module.exports = __webpack_public_path__ + "static/media/triangle-top.bc557b29.svg";


//////////////////
// WEBPACK FOOTER
// ./app/web/src/img/triangle-top.svg
// module id = 405
// module chunks = 0